/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entryticketshint2Inputs */

const en_entryticketshint2 = /** @type {(inputs: Entryticketshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free or paid`)
};

const de_entryticketshint2 = /** @type {(inputs: Entryticketshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos oder bezahlt`)
};

/**
* | output |
* | --- |
* | "Free or paid" |
*
* @param {Entryticketshint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entryticketshint2 = /** @type {((inputs?: Entryticketshint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entryticketshint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entryticketshint2(inputs)
	return de_entryticketshint2(inputs)
});
export { entryticketshint2 as "entryTicketsHint" }